export default "__VITE_ASSET__BlSww8rZ__"